
import React, { useEffect, useState } from "react";
import Skeleton from "@mui/material/Skeleton";

const GetFpssIdAll = ({ dist_code, afso_code, onLoadingChange, onChange }) => {
  const [options, setOptions] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!dist_code || !afso_code) return;

    const fetchFPS = async () => {
      try {
        setLoading(true);
        onLoadingChange(true);

        const response = await fetch(
          `${process.env.REACT_APP_URL_HEADER}/Common/getFPSsAll?dist_code=${dist_code}&afso_code=${afso_code}`
        );
        const data = await response.text();
        setOptions(data);
      } catch (error) {
        console.error("Error fetching FPS:", error);
      } finally {
        setLoading(false);
        onLoadingChange(false);
      }
    };

    fetchFPS();
  }, [dist_code, afso_code]);

  return (
    <div>
      {loading ? (
        <Skeleton width={100} height={40} />
      ) : (
        <select
          name="fps_id"
          id="fps_id"
          onChange={(e) => {
            console.log("FPS selected inside child:", e.target.value);
            onChange(e.target.value);
          }}
          dangerouslySetInnerHTML={{ __html: options }}
        />
      )}
    </div>
  );
};

export default GetFpssIdAll;